import { memo } from "react";

import { Typography } from "neetoui";
import PropTypes from "prop-types";

import "./page-loader.scss";

// Please update the https://github.com/bigbinary/neeto-commons-backend/blob/main/app/views/shared/_page_loader.html.erb#L1
// whenever there are some changes in the JSX.
// Styles changes will be handled by the release process.
const PageLoader = ({ text = "", ...otherProps }) => (
  <div className="neeto-molecules-pageloader__wrapper" {...otherProps}>
    <div className="neeto-molecules-pageloader neeto-ui-flex neeto-ui-flex-col neeto-ui-items-center neeto-ui-justify-center">
      <div
        className="neeto-molecules-pageloader__content neeto-ui-flex neeto-ui-flex-shrink-0 neeto-ui-items-center neeto-ui-justify-center"
        data-testid="neeto-molecules-pageloader"
      >
        <div className="neeto-molecules-pageloader__loader" />
      </div>
      {text && (
        <Typography style="h5" weight="semibold">
          {text}
        </Typography>
      )}
    </div>
  </div>
);

PageLoader.propTypes = {
  /**
   * Text to indicate loading status (optional).
   */
  text: PropTypes.string,
};

export default memo(PageLoader);
